// Header element for sidebar
const SideBarHeader = () => {
  return <header className="mm-pod-sidebar-header">
    <h2 className="mm-pod-sidebar-header-title mb-0">Your design</h2>
  </header>;
};

export default SideBarHeader;
